import React, { useEffect } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Stack,
    Select,
    Text,
    Box,
    HStack,
} from '@chakra-ui/react'
import Input from './Input';
import { useState } from 'react';
import { FaUser, FaUserAlt } from "react-icons/fa";
import Button from './Button';
import { CreateCategory, CreateStore, CreateUserApi, UpdateCategoryApi, UpdateStoreApi, UpdatedUserApi } from '../Utils/ApiCalls';
import { AiOutlineFieldNumber, AiTwotoneMail, AiFillShopping, AiOutlinePlus, AiOutlineMinus } from 'react-icons/ai';
import { FaShoppingCart } from 'react-icons/fa';
import StoreList from './StoreList';
import MsgCallback from './MsgCallback';
import { MdEmail } from 'react-icons/md';



export default function CreateUser({ isOpen, onOpen, onClose, state, singleData }) {





    const [Payload, setPayload] = useState(
        {
            email: "",
            store: "",
            usertype: ""


        }


    );

    const [UpdatedPayload, setUpdatedPayload] = useState(
        {
            email: "",
            store: "",
            usertype: ""


        }


    );

    const handlePayload = (e) => {
        setPayload({ ...Payload, [e.target.id]: e.target.value })
    }
    const handleUpdatedPayload = (e) => {
        setUpdatedPayload({ ...UpdatedPayload, [e.target.id]: e.target.value })
    }






    // console.log("updateStore", UpdateStore);

    const [errorMsg, setErrorMsg] = useState({
        status: false,
        msg: ""
    });

    const [SuccessMsg, setSuccessMsg] = useState({
        status: false,
        msg: "sdfgvhbnm"
    });


    const [Loading, setLoading] = useState(false);




    const handleCreateUser = async () => {

        try {
            setLoading(true)
            let result = await CreateUserApi(Payload);
            console.log("handleCreateUser result", result);
            if (result.status == true) {
                setLoading(false)
                setSuccessMsg({
                    status: true,
                    msg: "User created successfully"
                })

                setPayload({
                    email: "",
                    store: ""
                })

                setTimeout(() => {
                    setSuccessMsg({
                        status: false,

                    })

                    onClose()

                }, 2000);

            } else {

                setLoading(false)
                setErrorMsg({
                    status: true,
                    msg: result.msg
                })

                setTimeout(() => {
                    setErrorMsg({
                        status: false,

                    })

                }, 5000);

            }


        } catch (e) {

            setLoading(false)
            setErrorMsg({
                status: true,
                msg: e.message
            })
            console.error('Error:', e.message);
        }



    }
    const handleUpdatedUser = async () => {

        try {
            setLoading(true)
            let result = await UpdatedUserApi(UpdatedPayload, singleData[0]?._id);
            console.log("handleCreateUser result", result);
            if (result.status == true) {
                setLoading(false)
                setSuccessMsg({
                    status: true,
                    msg: "User Updated successfully"
                })

             

                setTimeout(() => {
                    setSuccessMsg({
                        status: false,

                    })

                    onClose()

                }, 1000);

            } else {

                setLoading(false)
                setErrorMsg({
                    status: true,
                    msg: result.msg
                })

                setTimeout(() => {
                    setErrorMsg({
                        status: false,

                    })

                }, 5000);

            }


        } catch (e) {

            setLoading(false)
            setErrorMsg({
                status: true,
                msg: e.message
            })

            setTimeout(() => {
                setErrorMsg({
                    status: false,

                })

            }, 2000);
            console.error('Error:', e.message);
        }



    }




    useEffect(() => {

        setUpdatedPayload(
           {
            email: singleData[0]?.email,
            store: singleData[0]?.store,
            usertype: singleData[0]?.usertype
           }
        )

    }, [isOpen]);
    return (



        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader textTransform="capitalize"> {state === "new" ? "Create new User ":"Update User information"}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>

            {
                state === "new" ? (

                    <Box>

                        <Stack spacing={"15px"}>
                            <Input leftIcon={<MdEmail />} iconColor="black" labelBg='#fff' label='Email' id="email" type='email' value={Payload.email} val={Payload.email != "" ? true : false} onChange={handlePayload} />


                            <Select w={["100%", "100%", "100%", "100%", "100%"]} borderColor={"#000"} color={"#000"} placeholder='Select Store' _focus={{ borderColor: "blue.blue400" }} fontWeight={"400"} fontSize={Payload.store != "" ? "16px" : "12px"} id='store' value={Payload.store} onChange={handlePayload}>

                               
                                <option value="2" >Central Circle stores, Ijora</option>
                                <option value="3" >East Circle stores, Island</option>
                                <option value="4" >West Circle stores, Festac</option>
                                <option value="9" >Technical Emergency </option>

                            </Select>

                            <Select w={["100%", "100%", "100%", "100%", "100%"]} borderColor={"#000"} color={"#000"} placeholder='Select User Type' _focus={{ borderColor: "blue.blue400" }} fontWeight={"400"} fontSize={Payload.usertype != "" ? "16px" : "12px"} id='usertype' value={Payload.usertype} onChange={handlePayload}>

                               
                                <option value="appadmin" >appadmin</option>
                                <option value="storeadmin" >storeadmin</option>
                            
                             

                            </Select>

                        </Stack>

                        <Button mt="14px" isLoading={Loading}
                            disabled={Payload.email !== "" && Payload.store !==""  && Payload.usertype !==""  ? false : true}
                            onClick={handleCreateUser}>Create User</Button>

                        <MsgCallback errorMsg={errorMsg} SuccessMsg={SuccessMsg} />
                    </Box>
                ):(
                    <Box>

                        <Stack spacing={"15px"}>
                            <Input leftIcon={<MdEmail />} iconColor="black" labelBg='#fff' label='Email' id="email" type='email' value={UpdatedPayload.email} val={UpdatedPayload.email != "" ? true : false} onChange={handleUpdatedPayload} />


                            <Select w={["100%", "100%", "100%", "100%", "100%"]} borderColor={"#000"} color={"#000"} placeholder='Select Store' _focus={{ borderColor: "blue.blue400" }} fontWeight={"400"} fontSize={UpdatedPayload.store != "" ? "16px" : "12px"} id='store' value={UpdatedPayload.store} onChange={handleUpdatedPayload}>

                               
                                <option value="2" >Central Circle stores, Ijora</option>
                                <option value="3" >East Circle stores, Island</option>
                                <option value="4" >West Circle stores, Festac</option>
                                <option value="9" >Technical Emergency </option>

                            </Select>

                            <Select w={["100%", "100%", "100%", "100%", "100%"]} borderColor={"#000"} color={"#000"} placeholder='Select User Type' _focus={{ borderColor: "blue.blue400" }} fontWeight={"400"} fontSize={UpdatedPayload.usertype != "" ? "16px" : "12px"} id='usertype' value={UpdatedPayload.usertype} onChange={handleUpdatedPayload}>

                               
                                <option value="appadmin" >appadmin</option>
                                <option value="storeadmin" >storeadmin</option>
                            
                             

                            </Select>

                        </Stack>

                        <Button mt="14px" isLoading={Loading}
                            disabled={UpdatedPayload.email !== "" && UpdatedPayload.store !=="" && UpdatedPayload.usertype !== ""? false : true}
                            onClick={handleUpdatedUser}>Update User</Button>

                        <MsgCallback errorMsg={errorMsg} SuccessMsg={SuccessMsg} />
                    </Box>
                )
            }



                </ModalBody>

                <ModalFooter>


                </ModalFooter>
            </ModalContent>
        </Modal>

    )
}
